import React, { useState } from "react";
import { DebounceCounter, debounce } from "src/common/debounce";
import { observer } from "mobx-react-lite";
import { CtrlFiltration } from "src/components/tables/TableStore";
import { InputProps } from "antd/lib";
import { PlmInputSearch } from "src/components/PlmInputSearch";
import { EntityFilters } from "./types";

const debounceCounter: DebounceCounter = {};

type PropsInputSearch = InputProps & { store: CtrlFiltration<EntityFilters> };

export const InputSearch: React.FC<PropsInputSearch> = observer(
  ({ store, ...props }) => {
    const [query, setQuery] = useState(store.filters?.query);
    return (
      <PlmInputSearch
        {...props}
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          debounce(debounceCounter, 300, () => {
            store.setFilters({
              ...store.filters,
              query: e.target.value,
            });
          });
        }}
      />
    );
  },
);
